'use client';

import { CookieBanner } from './CookieBanner';
import { CookieConsentProvider } from './CookieConsentProvider';

export function CookieConsentShell({ children }: { children: React.ReactNode }) {
  return (
    <CookieConsentProvider>
      {children}
      <CookieBanner />
    </CookieConsentProvider>
  );
}
